import { schema } from 'normalizr';

export const specialtySchema = new schema.Entity('specialty', {}, { idAttribute: '_id' });
export const specialtyListSchema = [specialtySchema];
